import { agentApiHeaders, apiBase, chatApiRequest } from '../agentApi'
import axios from '../axiosInstance'
import { ByoTool, ByoToolType, ChatApp } from './types'

/** Actions and tools share one endpoint, split by `?type=`. Keyed by name, not id. */

const toolsBase = (app: ChatApp): string => `${apiBase(app)}/ai-agents/tools`

export async function listTools(app: ChatApp, type: ByoToolType): Promise<ByoTool[]> {
  return chatApiRequest<ByoTool[]>(() =>
    axios.get(`${toolsBase(app)}?type=${type}`, { headers: agentApiHeaders(app) }),
  )
}

export async function deleteTool(app: ChatApp, name: string): Promise<unknown> {
  return chatApiRequest<unknown>(() =>
    axios.delete(`${toolsBase(app)}/${encodeURIComponent(name)}`, {
      headers: agentApiHeaders(app),
    }),
  )
}
